import { Component } from '@angular/core';
import { SavedPin } from '@models/teranet';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { SalePinState } from '@state/sale_pins';
import { Subject } from 'rxjs';
import { ICON } from '@core/util/icon';
import { SyncStatus } from './sync-inner-form/sync-inner-form.component';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@UntilDestroy()
@Component({
	selector: 'app-teranet-sync',
	templateUrl: './sync.component.html',
	styleUrls: ['./sync.component.scss'],
	standalone: false,
})
export class TeranetSyncDetailsComponent {
	@ViewSelectSnapshot(SalePinState.getPrimary) primary: SavedPin[];
	@SelectSnapshot(SelectedMatter.id) saleId: string;

	ICON = ICON;
	public submitSubject: Subject<void> = new Subject<void>();
	public syncStatuses = SyncStatus;
	public syncStatus;
	public error: string;

	constructor(private drawerService: DrawerService) {}

	setError(_error: string) {
		this.error = _error;
	}

	setSyncStatus(_syncStatus: SyncStatus) {
		this.syncStatus = _syncStatus;

		const syncTextMap = {
			[SyncStatus.NOT_SYNCING]: 'Confirm Sync',
			[SyncStatus.SYNCING]: 'Syncing',
			[SyncStatus.SYNCED]: 'Synced',
		};

		const syncText = syncTextMap[_syncStatus] || 'Confirm Sync';

		this.drawerService.setPrimaryAction(syncText, () =>
			this.submitSubject.next(),
		);
	}

	onSyncSuccess() {
		setTimeout(() => {
			this.drawerService.closeDrawer();
		}, 500);
	}
}
